export const VOYCE_STATUS = {
  NEW: 1,
  NO_INTERPRETER_AVAILABLE: 9,
  IN_SERVICE: 2,
  SERVICED: 3,
  CANCELLED: 4,
  INTERPRETER_ACCEPTED: 5,
};
